import type {
    SignalNameSegment,
    SignalNameSelectionOverflowOn,
} from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalNameSegments";
import type { Translatable } from "app/pages/sales-intelligence/types";

export type ParsedSignalDataSegment =
    | { kind: "plain"; segment: SignalNameSegment }
    | { kind: "withTimeframe"; selection: Translatable; timeframe: Translatable };

type SignalDataSegmentReplacements = {
    readonly name: Translatable;
    readonly timeframe: Translatable;
};

const isTranslatable = (value: unknown): value is Translatable =>
    typeof value === "object" && value !== null && typeof (value as Translatable).key === "string";

const isSignalDataSegmentReplacements = (value: unknown): value is SignalDataSegmentReplacements =>
    typeof value === "object" &&
    value !== null &&
    isTranslatable((value as { name?: unknown }).name) &&
    isTranslatable((value as { timeframe?: unknown }).timeframe);

export function parseSignalDataSegment(segment: SignalNameSegment): ParsedSignalDataSegment {
    const replacements = segment.replacements;

    if (isSignalDataSegmentReplacements(replacements)) {
        return { kind: "withTimeframe", selection: replacements.name, timeframe: replacements.timeframe };
    }

    return { kind: "plain", segment };
}

export function selectionOverflowOnForDataSegment(
    dataSegment: SignalNameSegment,
): Extract<SignalNameSelectionOverflowOn, "signalData" | "signalDataSelection"> {
    return parseSignalDataSegment(dataSegment).kind === "withTimeframe" ? "signalDataSelection" : "signalData";
}
